import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';


const InformationPillSkeleton = () => (
    <div className="pr-xxl pb-m">
        <Group direction="v" gap="s" alignItems="start">
            <SkeletonItem width={50} height={18}/>
            <SkeletonItem width={70} height={18}/>
        </Group>
    </div>
);

export const InformationSectionSkeleton = () => (
    <FormSection headline="Account Information" info={() => <SkeletonItem width={204} height={28}/>}>
        <div className="pb-s">
            <Group gap="none" wrap="wrap">
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
                <InformationPillSkeleton/>
            </Group>
        </div>
    </FormSection>
);
